import React from 'react';
import { useSelector } from 'react-redux';

export default function Overlay({ display }) {
    const darkMode = useSelector(state => state.theme.darkMode);

    if (display) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                background: darkMode ? '#120f0f99' : '#ffffff99',
                zIndex: 1000,
                top: 0,
                left: 0, position: 'absolute'
            }}>
                <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                <span style={{ marginTop: 10, fontWeight: 500 }}>Processing, please wait . . .</span>
            </div>
        );
    } else {
        return '';
    }
}
